import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function AuditTrail() {
  return (
    <PageTemplate
      title="Data: Audit Trail"
      tooltipText="Source-system audit trail: who performed which operation, when, and in which software module."
      type="source_audit_operations"
      constants={{
        wikiLink: "/wiki/guides/exploration-data-audittrail",
        idLink: undefined,
      }}
      selectionIdentifierColumn="person"
    />
  );
}
